/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-control-regex */
import React, { useEffect, useState } from 'react';
import Image from '../common/Image';
import { Link } from 'react-router-dom';
import Logo from '../common/components/images/logo-slogan.svg';

import { useAuth } from '../context/auth-context';
import { translateErrors } from '../utils';
import TextFields from '../common/components/TextField/TextField';

const containerStyle = {
    width: '100%',
    height: '94vh',
};

const resetError = {
    email: {
        hasError: false,
        message: '',
    },
    code: {
        hasError: false,
        message: '',
    },
    password1: {
        hasError: false,
        message: '',
    },
    password2: {
        hasError: false,
        message: '',
    },
};

const ChangePassword = (): JSX.Element => {
    const auth = useAuth();

    const [sended, setSended] = useState(false);
    const [passwordOk, setPasswordOk] = useState(false);
    const [error, setError] = useState(resetError);
    const [values, setValues] = useState({
        email: '',
        code: '',
        password1: '',
        password2: '',
    });

    const validateEmail = (email: string) => {
        // eslint-disable-next-line
        const expression =
            /(?!.*\.{2})^([a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        return expression.test(String(email).toLowerCase());
    };

    const validateFormEmail = () => {
        if (values && values.email === '' && values.email.length <= 0) {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: 'Email requerido!',
                },
            });
            return false;
        }

        if (!validateEmail(values.email)) {
            setError({
                ...error,
                email: {
                    hasError: true,
                    message: 'Verifica el Correo!',
                },
            });
            return false;
        }
        return true;
    };

    const passwordMatch = () => {
        setError(resetError);

        if (values.password1 !== values.password2) {
            setError({
                ...error,
                password1: {
                    hasError: true,
                    message: 'Las contraseñas deben coincidir!',
                },
                password2: {
                    hasError: true,
                    message: 'Las contraseñas deben coincidir!',
                },
            });
            return false;
        }
        return true;
    };

    function validateForm() {
        setError(resetError);
        if (values && values.password1 === '') {
            setError({
                ...error,
                password1: {
                    hasError: true,
                    message: 'Contraseña requerida!',
                },
            });
            return false;
        }
        if (values && values.password1.length < 8) {
            setError({
                ...error,
                password1: {
                    hasError: true,
                    message: 'Longitud minima de la contraseña 8 caracteres!',
                },
            });
            return false;
        }

        if (values && values.password2 === '') {
            setError({
                ...error,
                password2: {
                    hasError: true,
                    message: 'Repetir contraseña requerida!',
                },
            });
            return false;
        }

        if (values && values.password2.length < 8) {
            setError({
                ...error,
                password2: {
                    hasError: true,
                    message: 'Longitud minima de la contraseña 8 caracteres!',
                },
            });
            return false;
        }

        if (!passwordMatch()) {
            return;
        }

        //console.log('error', error);
        return true;
    }

    const handleSend = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setError(resetError);
        //console.log('sended');

        if (!validateFormEmail()) {
            return;
        }
        //console.log('validado');
        try {
            if (values && values.email) {
                await auth.forgotCode(values.email);
            } else {
                setError({
                    ...error,
                    email: {
                        hasError: true,
                        message: 'Ingresa el Correo!',
                    },
                });
            }
        } catch (e) {
            console.log('error handleChangePassword', e);
        }
    };

    const handleChangePassword = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        setError(resetError);
        //console.log('changed');

        if (!validateForm()) {
            return;
        }
        //console.log('validado');
        try {
            if (values && values.email && values.code && values.password1) {
                await auth.forgotConfirm(values.email, values.code, values.password1);
            } else {
                setError({
                    ...error,
                    email: {
                        hasError: true,
                        message: 'Datos Imcompletos!',
                    },
                });
            }

            setPasswordOk(true);
        } catch (e) {
            console.log('error handleChangePassword', e);
        }
    };

    const handleChangeEmail = (e: any) => {
        setError(resetError);
        auth.clearErrorAuth();
        setValues({ ...values, email: e.target.value });
    };

    const handleChangeCode = (e: any) => {
        setValues({ ...values, code: e.target.value });
    };

    const handleChangePassword1 = (e: any) => {
        setValues({ ...values, password1: e.target.value });
    };

    const handleChangePassword2 = (e: any) => {
        setValues({ ...values, password2: e.target.value });
    };

    useEffect(() => {
        if (auth) {
            setSended(auth.sendedForgot);
            if (auth.sendedForgot && auth.emailForgot) {
                setValues({ ...values, email: auth.emailForgot });
            }
            if (auth.passwordOk) {
                setPasswordOk(auth.passwordOk);
            }
            setError(resetError);
        }
    }, [auth]);

    return (
        <div className="relative">
            <div style={containerStyle} className="absolute z-10 bg-sm-blue-primary opacity-80" />
            <form
                className="absolute z-50 w-full flex justify-center items-center"
                style={containerStyle}
                onSubmit={sended ? handleChangePassword : handleSend}
            >
                <div className="mx-auto py-10 px-10 xl:px-40 sm:bg-sm-blue-primary  sm:bg-opacity-50 shadow-lg rounded-md w-full md:w-2/5">
                    <Image className="mx-auto" src={Logo} alt="SuperMatch - Juega donde y cuando quieras" height={62} />

                    {!sended && !passwordOk && (
                        <div className="flex flex-col my-6">
                            <TextFields
                                name={'email'}
                                id={'email'}
                                path={
                                    'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                }
                                label={'Ingresa tu email para recuperar la contraseña'}
                                type={'text'}
                                value={values.email}
                                placeholder={'Email'}
                                hasError={error.email.hasError}
                                messageError={error.email.message}
                                onChange={handleChangeEmail}
                                background={'dark'}
                            />
                        </div>
                    )}
                    {sended && (
                        <div className="flex flex-col my-6">
                            <p className="text-white text-center py-4">
                                Se envió un código a tu correo, escribe aquí el código y tu nueva contraseña
                            </p>

                            <TextFields
                                name={'code'}
                                id={'code'}
                                path={
                                    'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                }
                                label={'Código'}
                                type={'text'}
                                value={values.code}
                                placeholder={'Código'}
                                hasError={error.code.hasError}
                                messageError={error.code.message}
                                onChange={handleChangeCode}
                                background={'dark'}
                            />
                            <TextFields
                                name={'password1'}
                                id={'password1'}
                                path={
                                    'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                }
                                label={'Contraseña'}
                                type={'password'}
                                value={values.password1}
                                placeholder={'Contraseña'}
                                hasError={error.password1.hasError}
                                messageError={error.password1.message}
                                onChange={handleChangePassword1}
                                background={'dark'}
                            />
                            <TextFields
                                name={'password2'}
                                id={'password2'}
                                path={
                                    'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z'
                                }
                                label={'Repite contraseña'}
                                type={'password'}
                                value={values.password2}
                                placeholder={'Contraseña'}
                                hasError={error.password2.hasError}
                                messageError={error.password2.message}
                                onChange={handleChangePassword2}
                                background={'dark'}
                            />
                            <div className="w-full my-2">
                                {!error.password2.hasError && (
                                    <p className="text-xs text-white">La contraseña debe tener minimo 8 caracteres</p>
                                )}
                            </div>
                        </div>
                    )}
                    {passwordOk && (
                        <p className="mb-6 text-white py-10 font-bold text-xl text-center">
                            La contraseña ha sido cambiada{' '}
                            <Link to="/login" className="underline" href="/login">
                                ingresa aquí.
                            </Link>
                        </p>
                    )}
                    {auth.error && (
                        <p className="mb-6 text-sm text-red-200">{translateErrors(auth.error.statusCode)} </p>
                    )}
                    {!passwordOk && (
                        <>
                            {' '}
                            <div className="w-full text-right">
                                <Link to="/login" className="text-sm text-white" href="/">
                                    Volver a ingresar
                                </Link>
                            </div>
                            <button
                                type="submit"
                                onSubmit={sended ? handleChangePassword : handleSend}
                                className="w-full text-white px-4 py-4 rounded-lg text-lg mb-6 bg-sm-rent my-6"
                            >
                                {sended ? 'Cambiar contraseña' : 'Recuperar contraseña'}
                            </button>
                        </>
                    )}
                </div>
            </form>
        </div>
    );
};

export default ChangePassword;
